import { Component } from '@angular/core';
import { NgIf } from '@angular/common';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Toast } from 'ngx-toastr';

/** Clave de localStorage con el timestamp (ms) hasta el que se pospone el aviso de nueva versión */
export const VERSION_UPDATE_SNOOZE_KEY = 'versionUpdateSnoozeUntil';
const SNOOZE_MS = 5 * 60 * 60 * 1000;

/**
 * Toast de nueva versión: solo recarga al pulsar "Actualizar ahora".
 * Un clic sobre el cuerpo del aviso no hace nada.
 */
@Component({
  selector: '[update-toast-component]',
  standalone: true,
  imports: [NgIf],
  template: `
    <button type="button" class="toast-close-button" aria-label="Cerrar" (click)="cerrar($event)">
      <span aria-hidden="true">&times;</span>
    </button>
    <div *ngIf="title" [class]="options.titleClass">{{ title }}</div>
    <div *ngIf="message" role="alert" [class]="options.messageClass">{{ message }}</div>
    <div class="update-toast-actions">
      <button type="button" class="update-toast-btn update-toast-btn-primary" (click)="actualizar($event)">
        Actualizar ahora
      </button>
      <button type="button" class="update-toast-btn update-toast-btn-secondary" (click)="recordarLuego($event)">
        Recordar en 5 horas
      </button>
    </div>
  `,
  animations: [
    trigger('flyInOut', [
      state('inactive', style({ opacity: 0 })),
      state('active', style({ opacity: 1 })),
      state('removed', style({ opacity: 0 })),
      transition('inactive => active', animate('{{ easeTime }}ms {{ easing }}')),
      transition('active => removed', animate('{{ easeTime }}ms {{ easing }}')),
    ]),
  ],
})
export class UpdateToastComponent extends Toast {
  actualizar(event: Event) {
    event.stopPropagation();
    window.location.reload();
  }

  recordarLuego(event: Event) {
    event.stopPropagation();
    try {
      localStorage.setItem(VERSION_UPDATE_SNOOZE_KEY, String(Date.now() + SNOOZE_MS));
    } catch { }
    this.remove();
  }

  cerrar(event: Event) {
    event.stopPropagation();
    this.remove();
  }
}
